import styled from 'styled-components';
import { spacing, colors, Body2, Caption } from 'ui/theme';
import { Tooltip } from 'ui/tooltip';
import { CaptionUnderline, UlNoPadding } from './styled';
import { MemberRow } from '../types';
import { ORG_PERMISSION_NAMES_BY_KEY } from '../../../constants';

const TableCellCol = styled.div`
  display: grid;
  gap: ${spacing.quarter};
`;

const Body2NoMargin = styled(Body2)`
  margin-bottom: 0;
`;

const Permissions = styled(Caption)`
  color: ${colors.textSecondary};
  margin-bottom: 0;
`;

const TooltipWrapper = styled.div`
  justify-self: start;
`;

export const OrganizationRoleCell = ({ row }: { row: MemberRow }) => {
  const permissionCount = row.organizationPermissions?.length || 0;

  return (
    <TableCellCol>
      <Body2NoMargin>{row.orgAdmin ? 'Admin' : 'Member'}</Body2NoMargin>
      <TooltipWrapper>
        {permissionCount ? (
          <Tooltip
            tooltipContent={
              <UlNoPadding>
                {row?.organizationPermissions?.map((permission, index) => (
                  <li key={index}>{ORG_PERMISSION_NAMES_BY_KEY[permission]}</li>
                ))}
              </UlNoPadding>
            }
          >
            <CaptionUnderline>{permissionCount} permissions</CaptionUnderline>
          </Tooltip>
        ) : (
          <Permissions>{permissionCount} permissions</Permissions>
        )}
      </TooltipWrapper>
    </TableCellCol>
  );
};
